/**
 * The `cms-<collectionId>.json` filename convention for the stored CMS snapshot
 * files a generated code component imports as static JSON.
 *
 * Framework-free and dependency-free on purpose. The live-fetch/sync machinery
 * that once wrote these files has been removed; what remains is the parser
 * source-file GC relies on to recognize a stored snapshot and keep it from
 * being collected (a component references it by substring, not by import, so
 * the import graph always reads one as unused).
 */

const CMS_SNAPSHOT_FILE_NAME_RE = /^cms-(.+)\.json$/;

/**
 * Pull the collection id out of a `cms-<collectionId>.json` snapshot file name,
 * or `null` when the name is not a CMS snapshot.
 */
export function parseCmsSnapshotCollectionId(fileName: string): string | null {
  return CMS_SNAPSHOT_FILE_NAME_RE.exec(fileName)?.[1] ?? null;
}
